import { gql } from '@apollo/client'

const REQUEST_FIELDS = `
  _id status reason idempotencyKey version decidedAt decisionReason
  activity { _id title timeStart timeEnd minutes }
  requester { _id firstName lastName }
`

export const GET_ACTIVITY_CORRECTION_REQUESTS = gql`
  query getActivityCorrectionRequests {
    getActivityCorrectionRequests { ${REQUEST_FIELDS} changes createdAt }
  }
`

export const GET_MY_ACTIVITY_CORRECTION_REQUESTS = gql`
  query getMyActivityCorrectionRequests {
    getMyActivityCorrectionRequests { ${REQUEST_FIELDS} changes createdAt }
  }
`

export const ACTIVITY_CORRECTION_REQUEST_DECIDE = gql`
  mutation activityCorrectionRequestDecide($id: ID!, $input: ActivityCorrectionRequestDecisionInput!) {
    activityCorrectionRequestDecide(id: $id, input: $input) { ${REQUEST_FIELDS} }
  }
`
